/**
 * Settings (pages/Admin/AdminPanel.tsx) tab names, in one place so every
 * pointer to a tab — the no-access page, the employee form, org chart prompts,
 * Setup health fixes — names a tab people can actually find. Rename a tab here
 * and every reference follows.
 */
export const SETTINGS_TAB_LABELS = {
  access: 'Access & roles',
  'setup-health': 'Setup health',
  calendar: 'Calendar',
  preview: 'Role preview',
} as const;

/** The Settings tab where roles and logins are managed. */
export const ACCESS_TAB_LABEL = SETTINGS_TAB_LABELS.access;

/** "Settings → Access & roles", for sentences that send people there. */
export const ACCESS_TAB_LOCATION = `Settings → ${ACCESS_TAB_LABEL}`;

/** The route that opens the access tab. */
export const ACCESS_TAB_HREF = '/admin?tab=access';
